import { from } from "rxjs";
import { APIResource, APIMethod } from "libs/utils/http/decorator/UrlDecorator";
import { apiMethodContext } from "libs/utils/http/builder/UrlConfig";
import { CloudConsoleClient } from "libs/utils/http/client/HttpClient";
import "reflect-metadata";

export interface ApplicationTypeDetail {
  applicationType: string;
  grant_type: string;
  name?: string;
  isRedirectUriRequired?: boolean;
}

@APIResource(CloudConsoleClient, "publisher/v2/applications")
class ApplicationTypeServiceFactory {
  @APIMethod("/applicationTypes", {
    options: {
      noTrailingSlash: true,
    },
  })
  public getApplicationTypes() {
    return from(
      CloudConsoleClient.get<ApplicationTypeDetail[]>(apiMethodContext(arguments)).then(
        (value) => value.data
      )
    );
  }
}

const ApplicationTypeService = new ApplicationTypeServiceFactory();

export default ApplicationTypeService;
